import { useTranslation } from 'react-i18next';

export default function App() {
  const { t } = useTranslation();
  return (
    <main style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem' }}>
      <h1>{t('title', { ns: 'feb' })}</h1>
      <p>{t('tagline', { ns: 'feb' })}</p>
    </main>
  );
}
